import { useTranslation } from 'react-i18next';

import { WarningLevel } from '@/features/single-measurement/types';

import { InfoIcon } from '../info-icon';
import { WarningIcon } from '../warning-icon';

interface IProps {
  message?: string;
  level?: WarningLevel;
}

export const Warning: React.FC<IProps | null> = (warning) => {
  const { t } = useTranslation();
  return warning && warning.message ? (
    <div className="flex gap-10 items-center text-lg">
      <div>
        {warning.level === WarningLevel.Info ? <InfoIcon /> : null}
        {warning.level === WarningLevel.Warning ? <WarningIcon /> : null}
      </div>
      <div className="flex flex-col">
        <span className="font-bold">{t(`${warning.message}.title`)}</span>
        <span className="font-thin">{t(`${warning.message}.subtitle`)}</span>
      </div>
    </div>
  ) : null;
};
